module.exports = __webpack_public_path__ + "static/house-4752e663a1a04b08b7ee0dce83d5ccf3.png";